const mod = require('../bahabot.module.js')

mod.component('bbLayout', {
    templateUrl: 'tpl/layouts/layout.layout.html',
    bindings: {},
    controller: ["LayoutService", function(LayoutService) {
        this.layoutService = LayoutService;
    }]
});